import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import { ProgressRing } from "@/components/ProgressRing";
import { ShareAchievement } from "@/components/ShareAchievement";

export function WeeklyGoal({ goal, profile, streak }) {
  const done = goal?.done ?? 0;
  const target = goal?.target ?? 7;
  const achieved = !!goal?.achieved;
  const remaining = Math.max(0, target - done);

  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      className={`rounded-2xl border p-5 ${achieved ?"border-[#D4AF37]/50 bg-gradient-to-br from-[#D4AF37]/12 to-[#0D0D0F]" : "border-[#27272A] bg-[#121215]"}`}
      data-testid="weekly-goal-card"
    >
      <div className="flex items-center gap-4">
        <ProgressRing value={done} max={target} size={72} stroke={6} testid="weekly-goal-ring" label={achieved ? "Traguardo raggiunto" : `${done} di ${target} giorni`}>
          {achieved ? (
            <Trophy size={24} className="text-[#D4AF37]" />
          ) : (
            <span className="tabular-nums font-semibold text-base font-semibold text-[#FAF9F6]">{done}/{target}</span>
          )}
        </ProgressRing>
        <div className="min-w-0 flex-1">
          <p className="eyebrow" style={{ color: achieved ? "#D4AF37" : undefined }}>Traguardo della settimana</p>
          {achieved ? (
            <p className="mt-1.5 text-base leading-snug text-[#E8E4D8]">
              Hai completato tutti i <b className="text-[#D4AF37]">7 giorni</b>. Un risultato che merita di essere celebrato. 🏆
            </p>
          ) : (
            <p className="mt-1.5 text-base leading-snug text-[#B4B4BC]">
              Completa tutti i {target} giorni per sbloccare il tuo <b className="text-[#D4D4D8]">certificato condivisibile</b>.
              {remaining > 0 && <> Ti manca{remaining === 1 ? "" : "no"} <span className="tabular-nums font-semibold text-[#D4AF37]">{remaining}</span> giorn{remaining === 1 ? "o" : "i"}.</>}
            </p>
          )}
        </div>
      </div>

      {achieved && profile && (
        <div className="mt-4">
          <ShareAchievement arch={profile.archetype} dimension={profile.dimension} streak={streak} />
        </div>
      )}
    </motion.div>
  );
}
